import {
  PropsWithChildren, createContext, useContext, useMemo, useState,
} from 'react';
import { AlertModal, AlertModalType, AlertModalTypeEnum } from './AlertModal';

type ModalContextType = {
    showAlertModal: () => void,
    closeAlertModal: () => void,
    setAlertModalProps: (props: AlertModalType) => void,
}

export const ModalContext = createContext<ModalContextType>({
  showAlertModal: () => {},
  closeAlertModal: () => {},
  setAlertModalProps: () => {},
});

export function useAlertModal() {
  return useContext(ModalContext);
}

export function ModalProvider({ children }: PropsWithChildren) {
  const [alertModalIsOpen, setAlertModalIsOpen] = useState<boolean>(false);
  const [alertModalProps, setAlertModalProps] = useState<AlertModalType>({
    isOpen: alertModalIsOpen,
    content: '',
    type: AlertModalTypeEnum.INFORMATION,
  });

  const value = useMemo(() => ({
    showAlertModal: () => setAlertModalIsOpen(true),
    closeAlertModal: () => setAlertModalIsOpen(false),
    setAlertModalProps: (props: AlertModalType) => setAlertModalProps(props),
  }), []);

  return (
    <ModalContext.Provider value={value}>
      <AlertModal
        {...alertModalProps}
        isOpen={alertModalIsOpen}
      />
      {children}
    </ModalContext.Provider>
  );
}
